var $j = jQuery.noConflict();

$j(document).ready(function(){

    $j.fancybox.defaults.loop = true;
    $j.fancybox.defaults.hash = false;

    var app = {

        initialize: function(){
            this.setUpListners();
        },

        setUpListners: function(){

            // кнопка прокрутки вверх
            if(typeof wpfront_scroll_top == "function") wpfront_scroll_top({"scroll_offset":500,"button_opacity":1,"button_fade_duration":200,"scroll_duration":400,"hide_iframe":false,"auto_hide":true,"auto_hide_after":2});

            // цели
            // Открытие формы Заказать звонок в шапке
            $j('body').on('show.bs.modal', '#callbackmodal', function(){
                if(typeof yaCounter53195263 !== 'undefined'){
                    yaCounter53195263.reachGoal('form_callback_open');
                }
                //if (typeof ga == 'function') {
                //    ga('send', 'event', 'knopka', 'name_of_target');
                //}
            });

            $j(document).on('click', '.pages-list .menu-item-has-children a', function (e) {
                e.preventDefault();

                $j(this).next().stop(true, true).slideToggle();

                return false;
            });
        },
    };

    app.initialize();

	// if($j('.room_gallery_image').length) {
    //
	// 	$j('.room_gallery_image').each(function(indx, element){
	// 		$j(this).find("a[href$='.png'], a[href$='.PNG'], a[href$='.jpg'], a[href$='.JPG'], a[href$='.jpeg'], a[href$='.JPEG'], a[href$='.gif'], a[href$='.GIF'], a[href$='.bmp'], a[href$='.BMP']").attr("data-fancybox",'room_gallery_image'+indx).fancybox({
	// 			image : {
	// 				protect: true
	// 			}
	// 		});
	// 	});
    //
	// 	$j('.room_gallery_image').each(function(indx, element){
	// 		var INDX = $j(element).attr('data-room-number');
	// 		var SLIDES_COUNT = $j(element).children('.photo').length;
	// 		var asNavFor1;
	// 		var centerMode;
	// 		var slidesToShow = 3;
	// 		if (SLIDES_COUNT > slidesToShow) {
	// 			asNavFor1 = '.js_room_thumb'+INDX;
	// 			centerMode = true;
	// 		} else {
	// 			asNavFor1 = null;
	// 			centerMode = false;
	// 		}
    //
	// 		$j('.js_room_gal'+INDX).slick({
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1,
	// 			autoplay: false,
	// 			autoplaySpeed: 5000,
	// 			arrows: false,
	// 			fade: true,
	// 			//infinite: true,
	// 			prevArrow: '<div class="slick_control slick_prev"></div>',
	// 			nextArrow: '<div class="slick_control slick_next"></div>',
	// 			asNavFor: asNavFor1
	// 		});
    //
	// 		$j('.js_room_thumb'+INDX).slick({
	// 			slidesToShow: 3,
	// 			slidesToScroll: 1,
	// 			asNavFor: '.js_room_gal'+INDX,
	// 			dots: false,
	// 			centerMode: centerMode,
	// 			focusOnSelect: true,
	// 			centerPadding: 0,
	// 			arrows: true,
	// 			infinite: true,
	// 			prevArrow: '<div class="slick_control slick_prev"></div>',
	// 			nextArrow: '<div class="slick_control slick_next"></div>',
	// 			//responsive: [
	// 			//	{
	// 			//		breakpoint: 1200,
	// 			//		settings: {
	// 			//			slidesToShow: 4
	// 			//		}
	// 			//	},
	// 			//	{
	// 			//		breakpoint: 992,
	// 			//		settings: {
	// 			//			slidesToShow: 3
	// 			//		}
	// 			//	}
	// 			//]
	// 		});
	// 	});
    //
	// }

	// if($j('.guests_slider').length) {
    //
	// 	//$j(element).append('<div class="slick_control slick_prev"></div><div class="slick_control slick_next"></div>');
	// 	$j('.guests_slider').slick({
	// 		slidesToShow: 5,
	// 		slidesToScroll: 1,
	// 		autoplay: true,
	// 		autoplaySpeed: 3000,
	// 		arrows: true,
	// 		centerMode: true,
	// 		centerPadding: 0,
	// 		dots: false,
	// 		prevArrow: '<div class="slick_control slick_prev"></div>',
	// 		nextArrow: '<div class="slick_control slick_next"></div>',
	// 		responsive: [
	// 			//{
	// 			//	breakpoint: 992,
	// 			//	settings: {
	// 			//		slidesToShow: 3
	// 			//	}
	// 			//},
	// 			{
	// 				breakpoint: 768,
	// 				settings: {
	// 					slidesToShow: 3
	// 				}
	// 			}
	// 		]
	// 	});
	// }

	//$j('.carousel .gallery').each(function(indx, element){
	//	//$j(element).append('<div class="slick_control slick_prev"></div><div class="slick_control slick_next"></div>');
	//	$j(element).slick({
	//		slidesToShow: 5,
	//		slidesToScroll: 1,
	//		autoplay: false,
	//		autoplaySpeed: 2000,
	//		arrows: true,
	//		dots: false,
	//		prevArrow: '<div class="slick_control slick_prev"></div>',
	//		nextArrow: '<div class="slick_control slick_next"></div>',
	//		responsive: [
	//			{
	//				breakpoint: 1200,
	//				settings: {
	//					slidesToShow: 4
	//				}
	//			},
	//			{
	//				breakpoint: 992,
	//				settings: {
	//					slidesToShow: 3
	//				}
	//			},
	//			{
	//				breakpoint: 768,
	//				settings: {
	//					slidesToShow: 2
	//				}
	//			},
	//			{
	//				breakpoint: 480,
	//				settings: {
	//					slidesToShow: 1
	//				}
	//			}
	//		]
	//	});
	//});
	
	// var options = {
	// 	animateThreshold: 10, //сколько пикселей блока д.б. видно, чтобы началась анимация
	// 	scrollPollInterval: 20
	// };
	// $j('.foranimate').AniView(options);

	// 	$j('#home_slider').slick({
	// 		dots: true,
	// 		arrows: true,
	// 		prevArrow: '<div class="slick_control slick_prev"></div>',
	// 		nextArrow: '<div class="slick_control slick_next"></div>',
	// 		autoplay: true,
	// 		autoplaySpeed: 6000,
	// 		pauseOnHover: false
	// 	});
	// }



	// if ($j(window).width()>767 && $j('aside.sidebar').outerHeight(true) < $j('article').outerHeight(true) ) { // фиксируем правую часть если не мобильный
	// 	$j('.my_affix').affix({
	// 	  offset: {
	// 	    top: function () {
	//       		return ($j('aside.sidebar').offset().top)
	// 	    },
	// 	    bottom: function () {
	// 	    	return ( $j('body').height() - $j('div.clients').offset().top );
	// 	    }
	// 	  }
	// 	})
	// }
	

	// $j(window).scroll(function() {
		
	// 	var HEADER = $j('header'),
	// 		HEADERHEIGHT = HEADER.height(),
	// 		scrolltopfunct = $j(window).scrollTop();
		
	// 	if ($j(window).scrollTop() > HEADERHEIGHT && $j(window).width() > 767) {
	// 		$j('#topnav').addClass('fixed');
	// 		HEADER.addClass('forfixed');
	// 	} else {
	// 		$j('#topnav').removeClass('fixed');	
	// 		HEADER.removeClass('forfixed');
	// 	};
		

	// });
	
	var appforms = {
		
		initialize: function(){
			this.setUpListners();
		},
	
		setUpListners: function(){
			// $j('form.wpcf7-form').on('submit', appforms.submitForm);
            $j(document).on('click', 'form.wpcf7-form [type="submit"]', appforms.submitForm);
            $j(document).on('wpcf7submit', '.wpcf7', appforms.submitFormComplete); // Нужно для скрытия лоадера. Срабатывает, когда отправка формы Ajax успешно завершена, независимо от других инцидентов. https://contactform7.com/dom-events/
			$j('form.wpcf7-form').on('keydown, focus', 'input, textarea', appforms.removeError);
		},

		submitForm: function(e){
			// e.preventDefault();

            var form = $j(this).closest('form');
			
			if(appforms.validateForm(form) === false) return false;

            var loader = $j('#js_overlay_loader');
            loader.show();
			
		},

        submitFormComplete: function(e){
            var loader = $j('#js_overlay_loader');
            loader.hide();
        },
		
		validateForm: function(form){
			var inputs = form.find('.wpcf7-validates-as-required'),
				valid = true,
				placement = 'top';
			
			// if(form.is('.form-inline')){
			// 	placement = 'top';
			// }
			//
			// if(form.is('.form-horizontal')){
			// 	placement = 'right';
			// }
			//
			// if($j(window).width() < 768){
			// 	placement = 'top';
			// }
			
			//inputs.tooltip('destroy'); // без него тултипы не глючат
			
			$j.each(inputs, function(index, elem){
				var input = $j(elem),
					val = input.val(),
					// formGroup = input.closest('.form-group'),
					tooltiptitle = 'Обязательно',
					error = false;
				
				if(val.length === 0){
					error = true;
				}				
				else if(input.is('.wpcf7-email')){
					var reg= /^[a-zA-Z0-9\._-]+@[-a-zA-Z0-9_\.]{2,45}$/ ;
					if (!reg.test(val)) {
						tooltiptitle = 'Ошибка ввода E-mail';
						error = true;						
					}					
				}
				
				if(error){
					// formGroup.addClass('has-error').removeClass('has-success');
					input.tooltip({
						trigger: 'manual',
						placement: placement,
						title: tooltiptitle
					}).tooltip('show');
                    input.removeClass('is-valid');
                    input.addClass('is-invalid');
					valid = false;
				} else {
                    input.removeClass('is-invalid');
                    input.addClass('is-valid');
                    // formGroup.addClass('has-success').removeClass('has-error');
				}
			});

			return valid;
		},
	
		removeError: function(){
			// $j(this).tooltip('destroy').parents('.form-group').removeClass('has-error');
			$j(this).tooltip('dispose').removeClass('is-invalid');
		},
	};

	var app_refresh = {

		initialize: function(){
			this.setUpListners();
		},

		setUpListners: function(){

            // // прописываем параметры при открытии формы бронирования
            // $j('body').on('show.bs.modal', '#orderFormModal', function (event) {
            //     var button = $j(event.relatedTarget);
            //     var service = button.data('service');
            //     var inputTarget = $j('#orderFormTarget');
            //     inputTarget.val(service);
            // });

            $j('.custom-file-input').unwrap(); // чтобы удалить обертку span вокруг инпута, иначе не работает bsCustomFileInput
            bsCustomFileInput.init();

            var mycontainer = "article";
            $j(mycontainer+" a[href$='.png'],"+mycontainer+" a[href$='.PNG'],"+mycontainer+" a[href$='.jpg'],"+mycontainer+" a[href$='.JPG'], "+mycontainer+" a[href$='.jpeg'],"+mycontainer+" a[href$='.JPEG'],"+mycontainer+" a[href$='.gif'],"+mycontainer+" a[href$='.GIF'], "+mycontainer+" a[href$='.bmp'],"+mycontainer+" a[href$='.BMP']").not("a[download]").attr("data-fancybox","article-fancybox").fancybox({
                protect: true
            });

            $j('.gallery').each(function(indx, element){
                $j(this).find("a[href$='.png'], a[href$='.PNG'], a[href$='.jpg'], a[href$='.JPG'], a[href$='.jpeg'], a[href$='.JPEG'], a[href$='.gif'], a[href$='.GIF'], a[href$='.bmp'], a[href$='.BMP']").attr("data-fancybox",$j(element).attr('id')).fancybox({
                    protect: true
                });
            });

            // $j('.guests_slider').each(function(indx, element){
            //     $j(this).find("a[href$='.png'], a[href$='.PNG'], a[href$='.jpg'], a[href$='.JPG'], a[href$='.jpeg'], a[href$='.JPEG'], a[href$='.gif'], a[href$='.GIF'], a[href$='.bmp'], a[href$='.BMP']").attr("data-fancybox", 'guests_fancybox').fancybox({
            //         protect: true
            //     });
            // });

            $j("a.fancy").fancybox({
                protect: true
            });

            // var frontSlider = $j('#front-slider');
            // if (frontSlider.length) {
            //
            //     frontSlider.slick({
            //         dots: true,
            //         customPaging: function(slider, i) {
            //             return $j('<span></span>');
            //         },
            //         adaptiveHeight: true,
            //         arrows: true,
            //         prevArrow: '<div class="slick-control slick-prev fontello-left-open"></div>',
            //         nextArrow: '<div class="slick-control slick-next fontello-right-open"></div>',
            //         autoplay: true,
            //         autoplaySpeed: 6000,
            //         pauseOnHover: false
            //     });
            // }
            //
            // var feedbacksCarousel = $j('#feedbacks-slider');
            // if (feedbacksCarousel.length) {
            //
            //     feedbacksCarousel.slick({
            //         slidesToShow: 4,
            //         slidesToScroll: 1,
            //         dots: false,
            //         arrows: true,
            //         // infinite: true,
            //         prevArrow: '<div class="slick-control slick-prev fontello-left-open"></div>',
            //         nextArrow: '<div class="slick-control slick-next fontello-right-open"></div>',
            //         autoplay: true,
            //         autoplaySpeed: 2000,
            //         responsive: [
            //             {
            //                 breakpoint: 1200,
            //                 settings: {
            //                     slidesToShow: 4
            //                 }
            //             },
            //             {
            //                 breakpoint: 992,
            //                 settings: {
            //                     slidesToShow: 3
            //                 }
            //             },
            //             {
            //                 breakpoint: 768,
            //                 settings: {
            //                     slidesToShow: 3
            //                 }
            //             }
            //         ]
            //     });
            // }

            // var datepickers = $j('.js_room_datepicker');
            // datepickers.each(function(indx, element){
            //     var min_date = $j(this).data('min-date'),
            //         max_date = $j(this).data('max-date');
            //
            //     if (!min_date) min_date = null;
            //     if (!max_date) max_date = null;
            //     $j(this).datepicker({
            //         minDate: min_date,
            //         maxDate: max_date,
            //         changeMonth: true,
            //         changeYear: true,
            //         showButtonPanel: true
            //     });
            // });

            // для прописывания технических полей в формах обратной связи, чтобы знать, с какой страницы была отправлена форма
            $j('input.post_title').val($j('h1').text());
            $j('input.post_url').val(window.location.href);

            // // эффект параллакса при прокрутке
            // $j(window).scroll(function(){
            //     var scroll = $j(this).scrollTop(),
            //         bg = $j('.bg_parallax .bg'),
            //         bg_ratio = bg.data('parallax-ratio'),
            //         txt = $j('.banner_text_wrap'),
            //         txt_ratio = txt.data('parallax-ratio');
            //
            //     bg.css({
            //         'transform': 'translate3d(0,'+scroll*bg_ratio+'px,0)'
            //     });
            //
            //     txt.css({
            //         'transform': 'translate3d(0,'+scroll*txt_ratio+'px,0)'
            //     });
            // });

            $j('.modal').on('show.bs.modal', function (e) {
                $j('.tooltip').tooltip('dispose');
            });

            $j('input[type=tel]').mask("+7 (999) 999-99-99");

            file_upload();
		}
	};

	appforms.initialize();

    app_refresh.initialize();

    $j('body').on('click', 'a', function(e){

        // обрабатываем якорные ссылки
        if ( $j(this).is('[href *= "#"]') ) {

            var anchor = $j(this),
                scrollTop = $j(anchor.attr('href')).offset().top - 20;

            if ( $j(window).width()<992 ) {
                scrollTop -= 56;
            }

            $j('html, body').stop().animate({
                scrollTop: scrollTop
            }, 500);
            e.preventDefault();
            return false;
        }
        // тут остальные ссылки для подгрузки аяксом
        else if ( $j(this).is('[href ^= "http"], [href = "/"]') && !$j(this).is('[data-toggle], [data-fancybox], .noajax, [target="_blank"], .ab-item, .fancy, [href *= "/wp-content/uploads/"], [href*=#]') ){

            e.preventDefault();

            var url = $j(this).attr('href'),
                loader = $j('#js_overlay_loader');

            url = url.replace(/http:\/\//g, "//");
            url = url.replace(/https:\/\//g, "//");

            $j.ajax({
                type: 'GET',
                url: url,
                headers: { "X-Requested-With":"NULL" },
                beforeSend: function () {
                    loader.show();

                    // перематываем наверх
                    $j('html, body').stop().animate({
                        scrollTop: 0
                    }, 500);
                },
                success: function (data) {
                    $j('#js_ajax_wrapper').replaceWith($j(data).find('#js_ajax_wrapper'));

                    if ( $j('#wp-toolbar').length ) {
                        $j('#wp-toolbar').replaceWith($j(data).find('#wp-toolbar'));
                    }

                    var title = document.getElementById('doc_title').value;
                    document.title = title;

                    // $j('html, body').animate({
                    //     scrollTop: $j("body").offset().top
                    // }, 200);
                },
                error: function(){
                    // location=url;
                },
                complete: function(){
                    loader.hide();
                    history.pushState('', '', url);
                    app_refresh.initialize();
                }
            });

        }

    });

    window.addEventListener("popstate", function(e) {
        // Передаем текущий URL
        getContent(window.location.href, false);
    });

    // Функция загрузки контента
    function getContent(url, addEntry) {

        var loader = $j('#js_overlay_loader');

        $j.ajax({
            type: 'get',
            url: url,
            headers: { "X-Requested-With":"NULL" },
            beforeSend: function () {
                loader.show();
            },
            success: function (data) {
                $j('#js_ajax_wrapper').replaceWith($j(data).find('#js_ajax_wrapper'));

                var title = document.getElementById('doc_title').value;
                document.title = title;

                $j('html, body').animate({
                    scrollTop: $j("body").offset().top
                }, 200);
            },
            error: function(){
                window.location.href(url);
            },
            complete: function(){
                loader.hide();
                app_refresh.initialize();

                // if(addEntry == true) {
                //     history.pushState(null, null, url);
                // }
            }
        });
    }
	
});


function file_upload(){ // функция обработки input[type="file"]

    $j(".js_file_upload").each(function(indx, element){

        var file_upload = $j(element),
            inp = file_upload.find('input[type="file"]'),
            btn = file_upload.find(".file_btn"),
            lbl = file_upload.find(".file_name");

        inp.on('focus', function () {
            file_upload.addClass( "focus" );
        });
        inp.on('blur', function () {
            file_upload.removeClass( "focus" );
        });

        var file_api = ( window.File && window.FileReader && window.FileList && window.Blob ) ? true : false;
        inp.on('change', function () {
            var file_name = '';
            if( file_api && inp[0].files[0] ) {
                if (inp[0].files.length > 1) {
                    $j(inp[0].files).each(function(indx, element) {
                        // if ( file_name ) file_name += ', ';
                        file_name += '<i>'+ element.name +'</i>';
                    });
                } else {
                    file_name = '<i>'+ inp[0].files[0].name +'</i>';
                }
            } else {
                file_name = inp.val().replace( "C:\\fakepath\\", '' );
            }

            if( ! file_name.length ) return;

            //if( lbl.is( ":visible" ) ){
            lbl.html( file_name );
            //btn.text( "Выбрать" );
            //}else
            //	btn.text( file_name );
        });

        inp.change();
    });
}


window.onload = function () {
	$j('.preloader').addClass('loaded');
	$j('.overhid').removeClass('overhid');
};
